import { useDrfqWsStatus } from '#/unified-rfqs/contexts/drfqs';
import { useGrfqWebSocket } from '#/unified-rfqs/contexts/grfqs';
import { WebSocketStatus } from '#/unified-rfqs/services/shared';

export function useWsStatus(): WebSocketStatus {
  const grfqsWsStatus = useGrfqWebSocket();
  const drfqWsStatus = useDrfqWsStatus();

  const statusList = [grfqsWsStatus, drfqWsStatus]; // must never be empty

  return statusList.reduce(mergeStatus);
}

function mergeStatus(
  prev: WebSocketStatus,
  curr: WebSocketStatus,
): WebSocketStatus {
  return {
    error: prev.error.length > 0 ? prev.error : curr.error,
    connected: prev.connected && curr.connected,
    subscribed: prev.subscribed && curr.subscribed,
    subscribing: prev.subscribing || curr.subscribing,
  };
}
